// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__pAcUx","loader":"Loader_loader__mwU7T","spin":"Loader_spin__pRqME","rotate":"Loader_rotate__beiaZ","rotateccw":"Loader_rotateccw__qcOf7"};